import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { ImageBuilder } from '@jcom/common-components';
import { ImageRender } from './ImageRender';
import { commonUrl } from '../../Utils/StaticURLs';

const svgStyle = { width: '275px', height: '500px', margin: 'auto' };
const zoomStyle = { width: "100%", height: "auto", margin: "auto", maxWidth:"750px" };

function ImageWrapper({ template, colorsList, id, zoomImage, cssClassName, viewBox, setLoading, zoneImagePath, setZoneImagePath}) {
	const [renderSvg, setRenderSvg] = useState({});
	const [colorList, setColorList] = useState(null);
	const [baseColor, setBaseColor] = useState(null);
	const [trimColor, setTrimColor] = useState(null);
	const [imageList, setImageList] = useState(null);
	const [zoneName, setZoneName] = useState(null);
	const [zoneArea, setZoneArea] = useState(null);
	const [numberOfOccurance, setNumberOfOccurance] = useState(2);

	useEffect(() => {
		template &&
			isEmptyObject(template) !== {} &&
			axios
				.get(
					`${process.env.REACT_APP_JOSTENS_CDN_HOST}${template.product.mainImageRef}`,
					{
						headers: {
							'Access-Control-Allow-Origin': true,
						},
					}
				)
				.then((result) => {
					setRenderSvg(result.data);
				});

		if (template) {
			if (colorsList && colorsList.length) {
				setColorList(colorsList);
				renderSVG(
					template,
					colorsList,
					setBaseColor,
					setTrimColor,
					setImageList,
					setZoneName,
					setZoneArea,
					setLoading,
					zoneImagePath,
					setZoneImagePath
				);
			} else {
				const colorsKey = template.designSettings['colorList'];
				axios
					.get(commonUrl + '/' + colorsKey + '.json')
					.then((res) => {
						const colorList = res.data.colors;
						setColorList(res.data.colors);
						renderSVG(
							template,
							colorList,
							setBaseColor,
							setTrimColor,
							setImageList,
							setZoneName,
							setZoneArea,
							setLoading,
							zoneImagePath,
							setZoneImagePath
						);
					})
					.catch((err) => console.log(err));
			}
		}
	}, []);

	useEffect(() => {
		renderSVG(
			template,
			colorList,
			setBaseColor,
			setTrimColor,
			setImageList,
			setZoneName,
			setZoneArea,
			setLoading,
			zoneImagePath,
			setZoneImagePath
		);
	}, [template]);

	useEffect(() => {
		if (window.screen.width < 768) {
			setNumberOfOccurance(1);
		}
	}, []);

	const imgComp = ImageBuilder.svgImage({
		imgData: renderSvg,
		style: zoomImage ? zoomStyle : svgStyle,
		zoomImage: zoomImage,
		id: id,
		viewBox: viewBox,
	});

	return (
		<div className={`App ${cssClassName}`} id='stoleBuildImg'>
			<div
				style={{
					maxWidth: '100%',
					maxHeight: '500px',
					overflow: 'hidden',
					margin: '0 auto',
				}}>
				{renderSvg && (
					<>
						{imgComp}
						<ImageRender
							baseColor={baseColor}
							trimColor={trimColor}
							imageList={imageList}
							tipImage={template?.designSettings?.data?.designImageUrl}
							zoneName={zoneName}
							zoneArea={zoneArea}
							numberOfOccurance={numberOfOccurance}
						/>
					</>
				)}
			</div>
		</div>
	);
}

function isEmptyObject(obj) {
	return !obj || JSON.stringify(obj) === '{}';
}

async function getTextImageList(zones,threadColorName,setLoading,zoneImagePath, setZoneImagePath) {
	let zoneList = [];
	let textZone = [];
	zones.map((zone)=>{
		if((zone.data.decorType === 'text-v'  || zone.data.decorType === 'text-h') && zone.data.textLines.length) {
			let imagePath = zoneImagePath[zone.zoneCode];
			if(imagePath){
				let newData = { ...zone, data:{...zone.data, designImageUrl: imagePath} }
				zoneList.push(newData);
			} else {
				let data = zone.data.textLines;
				data = data.filter((text) => text);
				data.length ? textZone.push(zone) : zoneList.push(zone);
			}
		} else {
			zoneList.push(zone)
		}
	})
	setLoading(true)
	let textImages = await Promise.all(
		textZone.map(async (zone) => getTextImage(zone,threadColorName, setZoneImagePath))
	)
	setLoading(false)
	textImages.map((img, index) => {
		let zoneDetails = { ...textZone[index], data:{...textZone[index].data, designImageUrl: img} };
		zoneList.push(zoneDetails);
	});
	return zoneList;
}

function getTextImage(zone,threadColorName,setZoneImagePath) {
let zoneInfo = {
	...zone,
	data:{ ...zone.data, 'threadColorName': threadColorName}
}
	return axios
		.post(
			`${process.env.REACT_APP_JOSTENS_STOLE_BUILDER_HOST}/stoleAutoPreview`,
			zoneInfo
		)
		.then((res) => {
			let img = res && res.data && res.data.message;
			let zoneCode = zone.zoneCode;
			setZoneImagePath((images)=>({...images,[zoneCode]: img}));
			return img;
		})
		.catch((e) => {
			console.log(e);
			return '';
		});
}

async function getImageInfoFromZones(zones, threadColorName, setLoading, zoneImagePath, setZoneImagePath) {
	const zonesWithData = zones.filter(
				(zone) => !isEmptyObject(zone.data)
			);
	let zoneList = await getTextImageList(zonesWithData, threadColorName, setLoading, zoneImagePath, setZoneImagePath);
	const imageList = zoneList.map((zone) => {
		return {
			imgPath: zone.data.designImageUrl ? `${process.env.REACT_APP_JOSTENS_CDN_HOST}${zone.data.designImageUrl}` : '',
			x: zone.position && zone.position.x,
			y: zone.position && zone.position.y,
			imgWidth: zone.maxWidth,
			imgHeight: zone.maxHeight,
			zone: zone.zoneCode,
			isPatch: zone.data.patchFlag,
			isText: (zone.data.decorType === 'text-v' || zone.data.decorType === 'text-h'),
			groupCode: zone.data.groupCode
		};
	});

	return await loadImages(imageList);
}

function getZoneNames(zones) {
	const zoneNames = [];
	const zonePlace = [];
	zones &&
		zones.map((zone) => {
			let position = (zone && zone.position) || {};
			let right = zone.zoneCode && zone.zoneCode.includes('right');
			let y = zone.maxHeight > 6 ? position.y + zone.maxHeight / 2 : position.y;
			let name = {
				name: zone.zoneName && zone.zoneName.toUpperCase(),
				x: right ? -50 : 1060,
				y: 72 * y,
				align: right ? 'end' : 'start',
			};
			zoneNames.push(name);
			let place = {
				x: 72 * position.x,
				y: 72 * position.y,
				height: 72 * zone.maxHeight,
				width: 72 * zone.maxWidth,
			};
			zonePlace.push(place);
		});
	return { zoneNames, zonePlace };
}

async function renderSVG(
	template,
	colorList,
	setBaseColor,
	setTrimColor,
	setImageList,
	setZoneName,
	setZoneArea,
	setLoading,
	zoneImagePath,
	setZoneImagePath
) {
	if (colorList && colorList.length > 0) {
		let baseColor = '#' + template.designSettings.data.baseWebColor;
		let trimColor = '#' + template.designSettings.data.trimWebColor;
		let imgInfo = await getImageInfoFromZones(template.zones, template.designSettings.data.threadColorName, setLoading,
			zoneImagePath, setZoneImagePath);
		let { zoneNames, zonePlace } = getZoneNames(template.zones);
		setBaseColor(baseColor);
		setTrimColor(trimColor);
		setImageList(imgInfo);
		zoneNames && setZoneName(zoneNames);
		zonePlace && setZoneArea(zonePlace);
	}
}

export default ImageWrapper;

async function loadImages(imgList) {
	const imageDetails = await Promise.all(
		imgList.map(async (i) => getImageSize(i.imgPath))
	);
	let list = [];
	imageDetails.map((img, index) => {
		if (imgList[index].isPatch === 'y' || imgList[index].isPatch === 'Y') {
			let width = img.naturalWidth;
			let height = img.naturalHeight;
			let rectWidth = 72 * imgList[index].imgWidth;
			let rectHeight = 72 * imgList[index].imgHeight;
			let x = 72 * imgList[index].x;
			let y = 72 * imgList[index].y;
			let imageStartX = (x + rectWidth / 2 - width / 2) / 72;
			let imageStartY = (y + rectHeight / 2 - height / 2) / 72;
			let imgDetails = { ...imgList[index], x: imageStartX, y: imageStartY };
			list.push(imgDetails);
		} else if (imgList[index].isText && img) {
				let height = img.naturalHeight / 96;
				let width = img.naturalWidth / 96;
				if (height < imgList[index].imgHeight ) {
						let	x = imgList[index].x - (width / 2);
						let y = imgList[index].y - (height / 2);
						x = x + (imgList[index].imgWidth / 2);
						y = y + (imgList[index].imgHeight / 2);
						let imgDetails = { ...imgList[index], x: x, y: y, imgWidth:width, imgHeight:height };
						list.push(imgDetails);
				} else {
					list.push(imgList[index]);
				}
		} else {
			if(imgList[index].groupCode == "greek") {
				let height = img.naturalHeight / 96;
				let width = img.naturalWidth / 96;
		    let	x = imgList[index].x - (width / 2);
				let y = imgList[index].y - (height / 2);
		    x = x + (imgList[index].imgWidth / 2);
				y = y + (imgList[index].imgHeight / 2);
				let imgDetails = { ...imgList[index], x: x, y: y, imgWidth:width, imgHeight:height };
				list.push(imgDetails);
			} else {
				list.push(imgList[index]);
			}
		}
	});
	return list;
}

function getImageSize(src) {
	if(src){
		return new Promise((resolve, reject) => {
			let img = new Image();
			img.onload = () => resolve(img);
			img.onerror = reject;
			img.src = src;
		});
	} else {
		return null
	}
}
